import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { Card, Col, Row, Button, Form } from "react-bootstrap";
import { useParams } from 'react-router-dom';
import Wrapper from "../../components/Wrapper";
import { fetchPartners } from '../../store/features/partnersSlice';
import { fetchUserInfo } from '../../store/features/userInfo';
import { fetchFieldOfficersByAdminId } from '../../store/features/fieldOfficerByPartnerSlice';
import axiosInstance from '../../utils/axios';
import { getRole } from '../../utils/role';

const UserUpdatePartner = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const partnerData = useSelector((state) => state.partners);
    const { userInfo } = useSelector((state) => state.userInfo);
    const { fieldOfficers = [], status: fieldOfficersStatus = 'idle' } = useSelector(
        (state) => state.fieldOfficerByPartner || {}
    );

    const [selectedPartner, setSelectedPartner] = useState(null);
    const [selectedFieldOfficer, setSelectedFieldOfficer] = useState(null);
    const [selectedFarmToDelete, setSelectedFarmToDelete] = useState(null);
    const [infoToChangeSelector, setInfoToChangeSelector] = useState(null);
    const [newInfoValue, setNewInfoValue] = useState('');
    const [newFarmName, setNewFarmName] = useState(null);
    const [newFarmId, setNewFarmId] = useState(null);

    const currentRole = getRole();
    
    const isRestrictedRole = (currentRole === 'PARTNER' || currentRole === 'TEAM_MEMBER') || currentRole === 'FIELD_OFFICER';

    const allInfoToChange = [
        { name: 'first_name', label: 'First Name' },
        { name: 'last_name', label: 'Last Name' },
        { name: 'email_id', label: 'Email Address' },
        { name: 'mobile_no', label: 'Phone no.' },
        { name: 'address', label: 'Address' },
        { name: 'city', label: 'City' },
        { name: 'state', label: 'State' }, 
        { name: 'pincode', label: 'Pincode' }
    ];

    const infoToChange = isRestrictedRole 
        ? allInfoToChange.filter(info => info.name !== 'email_id' && info.name !== 'mobile_no')
        : allInfoToChange;

    useEffect(() => {
        if (partnerData.status === 'idle') {
            dispatch(fetchPartners({ page: 1, limit: 50 }));
        }
    }, [dispatch, partnerData.status]);

    useEffect(() => {
        dispatch(fetchUserInfo({ id }));
    }, [dispatch, id]);

    useEffect(() => {
        if (selectedPartner) {
            dispatch(fetchFieldOfficersByAdminId({ admin_id: selectedPartner }));
            setSelectedFieldOfficer(null); 
        }
    }, [selectedPartner, dispatch]);

    useEffect(() => {
        if (userInfo && userInfo.admin_id && !selectedPartner && fieldOfficersStatus === 'idle') {
            dispatch(fetchFieldOfficersByAdminId({ admin_id: userInfo.admin_id }));
        }
    }, [userInfo, userInfo?.admin_id, selectedPartner, dispatch, fieldOfficersStatus]);

    const updatePartnerAndFieldOfficer = async () => {
        console.log('@updatePartnerAndFieldOfficer');
        try {
            const payload = {
                user_id: id,
            };

            if (selectedPartner) {
                if (!selectedFieldOfficer) {
                    alert('Please select a field officer for the selected partner.');
                    return;
                }
                payload.admin_id = selectedPartner;
                payload.field_officer_id = selectedFieldOfficer;
            } else if (selectedFieldOfficer) {
                payload.field_officer_id = selectedFieldOfficer;
            } else {
                alert('Please select either a partner or a field officer.');
                return;
            }

            const { data } = await axiosInstance.put(`super-admin/update-user-partner`, payload);

            if (selectedPartner && data.admin_id === selectedPartner) {
                alert('Partner and Field Officer updated successfully.');
                dispatch(fetchUserInfo({ id }));
                setSelectedPartner(null);
                setSelectedFieldOfficer(null);
            } else if (selectedFieldOfficer && !selectedPartner && data.field_officer === selectedFieldOfficer) {
                alert('Field Officer updated successfully.');
                dispatch(fetchUserInfo({ id }));
                setSelectedFieldOfficer(null);
            } else {
                alert('Update completed successfully.');
                dispatch(fetchUserInfo({ id }));
                setSelectedPartner(null);
                setSelectedFieldOfficer(null);
            }
        } catch (err) {
            console.log(err);
            const errorMsg = err.response?.data?.message || err.response?.data?.error || 'Something went wrong. Please try again.';
            alert(errorMsg);
        }
    };

    const addFarm = async () => {
        console.log('@addFarm')
        try {
            const { data } = await axiosInstance.post(`super-admin/user-satyukt-farm`, {
                owned_by: id,
                farm_name: newFarmName,
                satyukt_farm_id: newFarmId
            });
            if (data.satyukt_farm_id === newFarmId) {
                alert('Farm added successfully.');
                dispatch(fetchUserInfo({ id }))
                setNewFarmName(null)
                setNewFarmId(null)
            }
            else alert('Something went wrong. Please try again.');
        } catch (err) {
            console.log(err);
            alert('Something went wrong. Please try again.');
        }
    }

    const udpateUserInfo = async () => {
        console.log('@udpateUserInfo')
        try {
            await axiosInstance.put(`super-admin/update-user-info`, {
                param: infoToChangeSelector,
                value: newInfoValue,
                user_id: id
            });
            alert('Info Updated successfully.');
            dispatch(fetchUserInfo({ id }))
            setInfoToChangeSelector('')
            setNewInfoValue('')
        } catch (err) {
            console.log(err);
            alert('Something went wrong. Please try again.');
        }
    }

    const deleteFarm = async () => {
        console.log('@deleteFarm')
        try {
            await axiosInstance.put(`super-admin/delete-user-satyukt-farm`, {
                farm_id: selectedFarmToDelete
            });
            alert('Deletion complted successfully.');
            dispatch(fetchUserInfo({ id }))
            setSelectedFarmToDelete(null)
        } catch (err) {
            console.log(err);
            alert('Something went wrong. Please try again.');
        }
    }

    const onPartnerOptionChangeHandler = (event) => {
        const partnerId = event.target.value || null;
        setSelectedPartner(partnerId);
        setSelectedFieldOfficer(null); 
    };

    const onFieldOfficerOptionChangeHandler = (event) => {
        setSelectedFieldOfficer(event.target.value || null);
    };

    const onFarmToDeleteOptionChangeHandler = (event) => {
        setSelectedFarmToDelete(event.target.value);
    };

    const infoToChangeOptionChangeHandler = (event) => {
        setInfoToChangeSelector(event.target.value);
    };

    return (
        <Wrapper>
            <Row className="g-3">
                <Col lg={6} className="r-5 order-2 order-lg-1">
                    {userInfo && userInfo.first_name &&
                        <Card>
                            <h2 className="fw-bolder">Farmer Information</h2>
                            <p>First Name: {userInfo.first_name || 'NA'}</p>
                            <p>Last Name: {userInfo.last_name || 'NA'}</p>
                            <p>Email: {userInfo.email_id || 'NA'}</p>
                            <p>Phone: {userInfo.mobile_no || 'NA'}</p>
                            <p>Address: {userInfo.address || 'NA'}</p>
                            <p>City: {userInfo.city || 'NA'}</p>
                            <p>State: {userInfo.state || 'NA'}</p>
                            <p>Pincode: {userInfo.pincode || 'NA'}</p>
                            <p>Partner: {userInfo.entity_name || 'NA'}</p>
                            <p>Field Officer: {userInfo.field_officer_name || 'NA'}</p>
                            {userInfo.field_officer_email && (
                                <p>Field Officer Email: {userInfo.field_officer_email}</p>
                            )}
                            {userInfo.field_officer_mobile && (
                                <p>Field Officer Mobile: {userInfo.field_officer_mobile}</p>
                            )}
                        </Card>
                    }

                    {!isRestrictedRole && (
                        <Card>
                            <h2 className="fw-bolder">Update Partner and Field Officer</h2>
                            <br />                        <Form.Label>Select Partner (Optional - leave empty to update field officer only)</Form.Label>
                            <Form.Select onChange={onPartnerOptionChangeHandler} value={selectedPartner || ''}>
                                <option value={''}>Please choose one partner (or leave empty to update field officer only)</option>
                                {partnerData.partners.map((option, index) => {
                                    return (
                                        <option key={index} value={option.admin_id}>
                                            {option.entity_name}
                                        </option>
                                    );
                                })}
                            </Form.Select>
                            <br />
                            <Form.Label>Select Field Officer {selectedPartner && '(Required)'}</Form.Label>
                            <Form.Select
                                onChange={onFieldOfficerOptionChangeHandler}
                                value={selectedFieldOfficer || ''}
                                disabled={(!selectedPartner && !userInfo?.admin_id) || fieldOfficersStatus === 'loading'} 
                            >
                                <option value="">
                                    {!selectedPartner && !userInfo?.admin_id
                                        ? 'Please select a partner first'
                                        : fieldOfficersStatus === 'loading'
                                            ? 'Loading field officers...'
                                            : 'Select Field Officer'}
                                </option>
                                {(selectedPartner || userInfo?.admin_id) &&
                                    fieldOfficersStatus === 'succeeded' &&
                                    Array.isArray(fieldOfficers) &&
                                    fieldOfficers.length > 0 &&
                                    fieldOfficers.map((fieldOfficer) => (
                                        <option
                                            key={fieldOfficer.field_officer_id}
                                            value={fieldOfficer.field_officer_id}
                                        >
                                            {fieldOfficer.name} {fieldOfficer.email_id ? `(${fieldOfficer.email_id})` : ''}
                                        </option>
                                    ))}
                            </Form.Select>
                            {(selectedPartner || userInfo?.admin_id) && fieldOfficersStatus === 'succeeded' && fieldOfficers && fieldOfficers.length === 0 && (
                                <Form.Text className="text-muted">
                                    No field officers found for this partner.
                                </Form.Text>
                            )}
                            <br />
                            <Button
                                onClick={updatePartnerAndFieldOfficer}
                                disabled={(!selectedPartner && !selectedFieldOfficer) || (selectedPartner && !selectedFieldOfficer)}
                            >
                                Update Partner and Field Officer
                            </Button>
                        </Card>
                    )}
                </Col>

                <Col lg={4} className="r-5 order-2 order-lg-1">
                    {!isRestrictedRole && (
                        <>
                            <Card>
                                <h2 className="fw-bolder">Farms</h2>
                                <p>Find all the farms associated here</p>
                                {userInfo && !userInfo.farms && <p>No farms found</p>}
                                {userInfo && userInfo.farms &&
                                    <Row>
                                        <Col><b>Farm Name</b></Col>
                                        <Col><b>GeoFence Id</b></Col>
                                    </Row>
                                }
                                {userInfo && userInfo.farms && userInfo.farms.map((farm, index) => {
                                    return (
                                        <Row key={index}>
                                            <Col>{farm.farm_name}</Col>
                                            <Col>{farm.satyukt_farm_id || 'NA'}</Col>
                                        </Row>
                                    );
                                })}
                            </Card>

                            <Card>
                                <h2 className="fw-bolder">Add Farm</h2>
                                <p>Add a farm to this farmer with GeoFence Farm Id</p>
                                <br />
                                <Form.Control onChange={(e) => setNewFarmName(e.target.value)} type="text" placeholder="Enter Farm Name" />
                                <br />
                                <Form.Control onChange={(e) => setNewFarmId(e.target.value)} type="text" placeholder="Enter GeoFence Farm Id" />
                                <br />
                                <Button
                                    variant="info"
                                    onClick={addFarm}
                                    disabled={!newFarmName || !newFarmId ? true : false}
                                >
                                    Add Farm
                                </Button>
                            </Card>

                            <Card>
                                <h2 className="fw-bolder">Delete Farm</h2>
                                <p>Delete a farm</p>
                                <br />
                                {userInfo && !userInfo.farms && <p>No farms found to delete.</p>}
                                {userInfo && userInfo.farms &&
                                    <select onChange={onFarmToDeleteOptionChangeHandler}>
                                        <option value={''}>Select the farm to be deleted</option>
                                        {userInfo.farms.map((option, index) => {
                                            return (
                                                <option key={index} value={option.farm_id}>
                                                    {option.farm_name} {'-'} {option.satyukt_farm_id || 'NA'}
                                                </option>
                                            );
                                        })}
                                    </select>
                                }
                                <br />
                                <Button
                                    variant="danger"
                                    disabled={!selectedFarmToDelete ? true : false}
                                    onClick={deleteFarm}
                                >
                                    Delete Farm
                                </Button>
                            </Card>
                        </>
                    )}

                    <Card>
                        <h2 className="fw-bolder">Update Info</h2>
                        <p>Update Farmer's Info.</p>
                        <br />
                        <select onChange={infoToChangeOptionChangeHandler}>
                            <option value={''}>Select attribute to update.</option>
                            {infoToChange.map((option, index) => {
                                return (
                                    <option key={index} value={option.name}>
                                        {option.label}
                                    </option>
                                );
                            })}
                        </select>
                        <br />
                        <Form.Control onChange={(e) => setNewInfoValue(e.target.value)} value={newInfoValue} type="text" placeholder="Enter New Value" />
                        <br />
                        <Button
                            variant="info"
                            onClick={udpateUserInfo}
                            disabled={!infoToChangeSelector || !newInfoValue ? true : false}
                        >
                            Update Info
                        </Button>
                    </Card>
                </Col>
            </Row>
        </Wrapper>
    );
}

export default UserUpdatePartner;